<template>
  <div>
    <v-menu offset-y :disabled="loading">
      <v-btn
        slot="activator"
        color="primary"
        class="text-none binary-change"
        :loading="loading"
      >
        {{ currentLabel }}
      </v-btn>

      <v-list>
        <v-list-tile
          v-for="(item, index) in menuOptions"
          :key="index"
          @click="openConfirmDialog(item.value)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialogConfirm" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          $t("change-binary-direction")
        }}</v-card-title>
        <v-card-text>
          <span
            v-html="
              $t('change-binary-direction-from-to', [currentLabel, nextLabel])
            "
          ></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-unset"
            small
            light
            flat
            @click="dialogConfirm = false"
          >
            {{ $t("common.no") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-unset"
            small
            dark
            @click="confirmChange"
            >{{ $t("common.yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="300">
      <v-card>
        <v-card-text class="text-xs-center pt-4">
          {{ $t("binary-direction-changed") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-unset"
            small
            dark
            @click="dialogSuccess = false"
            >Ok</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from "graphql-tag";

const UPDATE_INVITE_MUTATION = gql`
  mutation UpdateInvite($leg: Int!) {
    updateInvite(leg: $leg)
  }
`;

export default {
  name: "BinaryLegSelector",
  props: {
    leg: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      dialogConfirm: false,
      dialogSuccess: false,
      pendingValue: null,
    };
  },
  computed: {
    menuOptions() {
      return [
        { title: this.$i18n.t("leg-auto"), value: 0 },
        { title: this.$i18n.t("leg-left"), value: 1 },
        { title: this.$i18n.t("leg-right"), value: 2 },
      ];
    },
    currentLabel() {
      const activeOption = this.menuOptions.find(
        (opt) => opt.value === this.leg
      );
      return activeOption ? activeOption.title : "";
    },
    nextLabel() {
      const nextOption = this.menuOptions.find(
        (opt) => opt.value === this.pendingValue
      );
      return nextOption ? nextOption.title : "";
    },
  },
  methods: {
    openConfirmDialog(value) {
      if (value === this.leg) return;
      this.pendingValue = value;
      this.dialogConfirm = true;
    },
    async confirmChange() {
      this.dialogConfirm = false;
      this.loading = true;

      try {
        const result = await this.$apollo.mutate({
          mutation: UPDATE_INVITE_MUTATION,
          variables: { leg: this.pendingValue },
        });

        if (result.data && result.data.updateInvite) {
          this.$emit("update:leg", this.pendingValue);
          this.dialogSuccess = true;
        }
      } catch (error) {
        console.error("Napaka pri posodabljanju binarne smeri:", error);
      } finally {
        this.loading = false;
        this.pendingValue = null;
      }
    },
  },
};
</script>

<style scoped>
.text-none {
  text-transform: none !important;
}

.binary-change {
  padding: 2px 1px !important;
  height: 16px !important;
  min-width: 45px !important;
  font-size: 10px;
}
</style>